<template>
  <div class="lhsx">
    <img src="./dhqhLogo.png" width="25%" height="20%" class="positionSion" alt="" />
    <img src="./title.png" width="80%" height="40%" class="positionSionTwo" alt="" />
    <form id="form"  method="post" onsubmit="return false" action="##">
      <!-- <input type="text" class="name" placeholder="请输入真实姓名"
        @input="formData.clientName=formData.clientName.replace(/[^\u4E00-\u9FA5]/g,'')" v-model="formData.clientName"
        id="inputEmail3" /> -->
      <input type="number" class="clientMobile" placeholder="请输入手机号码" v-model="formData.clientMobile" />
      <input type="text" class="code" placeholder="请输入验证码" v-model="formData.code" />
      <button class="send" :class="{ disable: this.verifyMsg !== '获取验证码'}" @click="sendCode()">{{ verifyMsg }}</button>
        <div class="ystk">
        <van-checkbox icon-size="14px" v-model="checked" checked-color	="#ffc500"><span></span> </van-checkbox><span style="color:#ffff;font-size:14px" @click="ystkShow">我已阅读并同意东航期货风险提示和隐私条款</span>
      </div>
      <div class="btn" @click="submit()">立即下载APP</div>
       <div class="coloryellow">
        稍后会有工作人员会尽快与您联系
      </div>
    </form>
    <!-- <img src="./3(1).png" width="100%" height="82%" alt="" /> -->
    <div class="firstInput">
      <div class="topImg">
         <div class="title">重磅福利</div>
      </div>
      <div class="content">
        <div class="fee">
          <div class="spanTitle"><span style="margin-left:0px">优惠手续费率</span></div>
          <div class="spanContent"><span>新开户客户，无资金门槛要求，各品种期货、期权，通通一手只加一分钱!</span></div>
          <div class="spanStyle"><span>(不含交易所手续费及投资者保障基金)</span></div>
        </div>
        <div class="fancyNumber">
           <div class="spanTitleTwo"><span style="margin-left:0px">免费期货靓号</span></div>
          <div class="spanContent"><span>如尾号「666」、「888」等靓号数量有限，先到先得!</span></div>
          <div class="spanStyle"><span>(温馨提示:请在提交资料后7日内完成开户哦)</span></div>
        </div>
      </div>
    </div>
     <div class="firstInputOne">
      <div class="topImg">
         <div class="title">公司背景</div>
      </div>
      <div class="content">
        <div class="threeFee">
          <div class="imgDiv">
            <img src="./company.png" width="100%"  alt="" />
          </div>
          <div class="textSpan">东航期货成立于1995年，总部设于上海</div>
        </div>
        <div class="threeFee">
          <div class="imgDiv">
            <img src="./service.png" width="100%"  alt="" />
          </div>
          <div class="textSpan">专注提供期货开户，行情交易服务</div>
        </div>
        <div class="threeFee">
          <div class="imgDiv">
            <img src="./sponsor.png" width="100%"  alt="" />
          </div>
          <div class="textSpan">国内知名期货实盘大赛“蓝海密剑”主办方</div>
        </div>
      </div>
    </div>
    <div class="btn" @click="backTop()">立即下载APP</div>
    <div class="bottomBanner">
      <span style="margin-top:20px;color:rgb(255,220,99);margin-left:0px;">从事证券投资或期货交易，请通过合法证券期货经营机构进行。合法机构名单可到中国证监会网站(www.csrc.gov.cn)查询。</span>
      <span style="margin-top:20px;color:#fff;font-size:14px">———— 交易有风险 入市需谨慎 ————</span>
       <img style="margin-top:20px" src="./dhqhLogo.png"  width="120px"  height="30px" alt="" />
    </div>
    <div class="Statement">
      <span style="color:#fff;display: inline-block;;font-size:14px">东航期货有限责任公司版权所有</span>
      <span style="margin-top:5px;margin-bottom:20px;color:#fff;display: inline-block;;font-size:14px">经营证券期货业务许可证编号:000000061878</span>
    </div>
    <alert :showModal.sync="showAlert">{{ alertMessage }}</alert>
    <van-overlay :show="showOverlay" :lock-scroll="false" @click="showOverlay = false">
      <div class="wrapper" @click.stop>
        <ystk @close="close"/>
      </div>
    </van-overlay>
  </div>
</template>


<script>
  /* eslint-disable */
  import ajax from "@/common/ajax/ajax";
  import alert from "@/components/alert/alert";
  import ystk from "@/page/lhsx/ystk"
  import List from '../../components/list/List.vue'; 
  export default {
    data() {
      return {
        formData: {
          channel: "0",
          clientName: "暂无",
          clientMobile: "",
          code: "",
         
        },
        showAlert: false,
        alertMessage: "",
        verifyMsg: "获取验证码",
        wait: 30,
        showOverlay: false,
        checked:false 
      };
    },
    components: { alert,ystk},
    mounted() {
    },
    methods: {
      sendCode() {
        if (this.verifyMsg !== '获取验证码') {
          this.alertMessage = '验证码请求太快请稍等'
          this.showAlert = true
          return
        }
        // if (!this.formData.clientName || this.formData.clientName.length < 2) {
        //   this.alertMessage = "请输入真实姓名";
        //   this.showAlert = true;
        //   return;
        // }

        var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/; //11位手机号码正则
        if (!reg_tel.test(this.formData.clientMobile)) {
          this.alertMessage = "请输入正确的手机号码";
          this.showAlert = true;
          return;
        }
        let senddata = {
          mobile: $.trim(this.formData.clientMobile),
          type: 1003,
        };

        ajax.sendCodeLhsx(senddata).then((data) => {
          let vm = this
          function time() {
            if (vm.wait === 0) {
              vm.verifyMsg = '获取验证码'
              vm.wait = 30
            } else {
              vm.verifyMsg = vm.wait + '秒后重新发送'
              vm.wait--
              setTimeout(function () {
                time()
              }, 1000)
            }
          }

          time()
          let str = data.data.resultMessage;
        }).catch((err) => {
          this.alertMessage = "获取验证码失败"
          this.showAlert = true
        })
      },
      submit: function () {
        // if (!this.formData.clientName || this.formData.clientName.length < 2) {
        //   this.alertMessage = "请输入真实姓名";
        //   this.showAlert = true;
        //   return;
        // }
        var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/; //11位手机号码正则
        if (!reg_tel.test(this.formData.clientMobile)) {
          this.alertMessage = "请输入正确的手机号码";
          this.showAlert = true;
          return;
        }
        if (!this.formData.code) {
          this.alertMessage = "验证码不能为空";
          this.showAlert = true;
          return;
        }
         if (!this.checked) {
          this.alertMessage = "请阅读并同意东航期货风险提示和隐私条款";
          this.showAlert = true;
          return;
        }
        let key = "907b067cd20ff4d0e7b928b0a1029b2a";
        if (this.$route.query.proID) {
          this.$set(this.formData, 'proID', this.$route.query.proID)
        }
        this.$forceUpdate()
        let senddata = this.utils.encrypt(JSON.stringify(this.formData), key);
        ajax.loginLhsx(senddata).then((data) => {
          if (data.data.resultStatus == 0) {
            if (data.data.data.needBack == 1) {
                _baq.track("form", { assets_id: "1840774563574024" })//新版有参数
            }
            window.location.href = "https://www.chengzijianzhan.com/tetris/page/7538694069615099942/"
          } else {
            this.alertMessage = data.data.resultMessage
            this.showAlert = true
          }
        }).catch((err) => {
          this.alertMessage = "申请失败"
          this.showAlert = true
        })
      },
      backTop() {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      },
       ystkShow() {
        this.$router.push('dhqhystk')
      },
      close() {
        this.showOverlay = false
      }
    }
  }
</script>

<style scoped>
  .lhsx {
    background: url("./BGB.png") no-repeat;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-size: 100% 100%;
    padding: 20px 0;
    overflow: hidden;
  }
  .positionSion{
    margin: 10px 5%;
  }
  .positionSionTwo{
    margin: 10px 10%;
    padding-top: 10px;
  }
  /* 响应式调整 */
    @media (min-width: 400px) {
       .firstInput{
        background: url("./bigger.png") no-repeat;
        background-size: cover;
        width: 100%;
        min-height: 340px;
        margin-top: 20px;
        position: relative;
        border: none;
      }
     .firstInputOne{
       background: url("./bigger.png") no-repeat;
       background-size: cover;
       width: 100%;
       min-height: 340px;
       margin-top: 50px;
       position: relative;
       border: none;
    }
     .threeFee{
    background: url("./textBox.png") no-repeat;
    background-size: cover;
    width: 100%;
    height:80px;
    margin-top: 10px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }

    }
  @media (max-width: 399px) {
      .firstInput{
    background: url("./bigger.png") no-repeat;
    background-size: cover;
    background-position: center;
    width: 100%;
    min-height: 300px;
    margin-top: 20px;
    position: relative;
    border: none;
  }
    .firstInputOne{
    background: url("./bigger.png") no-repeat;
    background-size: cover;
    background-position: center;
    width: 100%;
    min-height: 300px;
    margin-top: 50px;
    position: relative;
    border: none;
  }
  .threeFee{
    background: url("./textBox.png") no-repeat;
    background-size: cover;
    width: 100%;
    height:70px;
    margin-top: 10px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
  }
  .firstInputTwo{
      background: url("./bigger.png") no-repeat;
    background-size: cover;
    width: 100%;
    height: 160px;
    margin-top: 50px;
    position: relative;
    border: none;
  }
  .textSpan{
    width: 70%;
    font-size: 15px;
    font-weight: 1000;
    color: #57191a;
  }
  .topImg{
    background: url("./titleBanner.png") no-repeat;
    background-size: cover;
    position: absolute;
    top: -15px;
    width: 70%;
    margin-left: 15%;
    height: 48px;
  }
  .title{
    text-align: center;
    font-size: 20px;
    font-weight: bolder;
    line-height: 55px;
    color: #f94807;
  }
  .imgDiv{
    width: 60px;
    height: 60px;
  }
  .content{
    width: 84%;
    height: 80%;
    position: relative;
    top: 40px;
    left: 8%;
  }
  .fee{
    background: url("./textBox.png") no-repeat;
    background-size: cover;
    width: 100%;
    height:50%;
    padding-top: 10px;
  }
  .spanTitle{
    font-size: 18px;
    width: 44%;
    background: url("./7.png") no-repeat;
    background-size: cover;
    text-align: center;
    letter-spacing: 2px;
    margin-left: 8%;
    color: #FFFFFF;
    border-radius: 12px;
  }
  .ystk {
    display: flex;
    justify-content: center;
    margin-top: -10px;
    margin-bottom: 10px;
  }
  .ystk span:nth-child(1) {
    color: #feef06;
    padding: 0px 5px;
  }
  .ystk span:nth-child(2) {
    color: #dddddd;
  }

  .spanTitleTwo{
    font-size: 18px;
    width: 44%;
    text-align: center;
    letter-spacing: 2px;
    margin-left: 8%;
    background: url("./7.png") no-repeat;
    background-size: cover;
    color: #FFFFFF;
    border-radius: 12px;
  }
  .bottomBanner{
    width: 90%;
    margin-left: 5%;
    height: 220px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .italic‌{
    font-style: oblique;
    font-size: 15px;
    text-align: center;
    color: rgb(154,80,27);
  }
  .Statement{
    width: 90%;
    margin-left: 5%;
    height: 55px;
    text-align: center;
  }
  .spanContent{
    height: 40%;
    margin-left: 8%;
    margin-top: 10px;
    text-indent: 1ch;
    font-size: 14px;
    width: 90%;
    white-space: normal;
    color: #4b0509;;
  }
  .spanStyle{
    margin-left: 8%;
    display: inline-block;
    line-height: 14px;
    text-indent: 2ch;
    font-size: 13px;
    width: 100%;
    color: #615f5b;
  }
  .fancyNumber{
    background: url("./textBox.png") no-repeat;
    background-size: cover;
    margin-top: 2%;
    width: 100%;
    height:50%;
    padding-top: 10px;
  }
  #form {
    text-align: center;
    position: relative;
    padding: 30px 0;
    padding-top: 10px;
  }
 .coloryellow{
    color: #fff;
    margin-top: 5px;
    font-size: 14px;
  }
  input {
    width: 80%;
    height: 40px;
    line-height: 40px;
    padding-left: 12px;
    color: #323232;
    font-size: 14px;
    margin-bottom: 25px;
    border: 1px solid #fff;
  }

  .name {
    padding-left: 40px;
    background-image: url("1-1.png");
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: 8px 8px;
  }

  .clientMobile {
    padding-left: 40px;
    background-image: url("1-2.png");
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: 8px 8px;
  }

  .code {
    padding-left: 40px;
    background-image: url("1-3.png");
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: 8px 8px;
  }

  .btn {
    background: url("./1-5.png") center center no-repeat;
    width: 40%;
    height: 40px;
    background-size: 100% 100%;
    text-align: center;
    font-size: 16px;
    color: #fff;
    line-height: 40px;
    margin: 18px 0 0 30%;
  }

  .backtop {
    background: url("./1-5.png") center center no-repeat;
    width: 40%;
    height: 40px;
    background-size: 100% 100%;
    border: #fff;
  }

  .topdiv {
    text-align: center;
    margin-top: 30px;
    padding-bottom: 15px;
  }

  .send {
    background: #ffc500;
    border: #fff;
    font-size: 14px;
    color: #fff;
    width: 115px;
    height: 30px;
    line-height: 30px;
    position: absolute;
    right: 12%;
    bottom: 59%;
  }

  .disable {
    background: #ccc;
    border: #ccc;
  }
</style>


// WEBPACK FOOTER //
// index.vue?1593558f